// src/utils/url.js

// Hämta bas-URL för publika resurser (bilder m.m.)
// - I dev: http://localhost:5000 (din backend)
// - I prod: window.location.origin (https://app.kmaavfall.se)
// - Kan överskridas via REACT_APP_PUBLIC_BASE_URL i frontendens .env
export function publicBase() {
  const env = process.env.REACT_APP_PUBLIC_BASE_URL;
  if (env) return env.replace(/\/+$/, ''); // ta bort ev. trailing slash

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000';
  }
  // production
  return (typeof window !== 'undefined' && window.location)
    ? window.location.origin
    : '';
}

// Bygg en absolut URL till en bild/fil.
// Tar emot antingen en absolut URL (http...) eller ett relativt path (/uploads/xxx.png)
export function picUrl(u) {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u; // redan absolut

  const base = publicBase();
  const path = u.startsWith('/') ? u : `/${u}`;
  return base ? `${base}${path}` : path;
}
